<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-3xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  autocomplete="off"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold" v-if="updating === true">
                                                Update User `{{ form.first_name }} {{ form.last_name }}`
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white font-bold" v-else>
                                                Create User
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white" v-if="updating === false">
                                                Get started by filling in the information below to create a new
                                                user.
                                            </p>
                                            <p class="text-sm text-white" v-else>
                                                Make any changes to the user by updating the information below.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="pt-6 pb-5 grid grid-cols-3 gap-4">
                                                <div class="col-span-3">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">User
                                                        Information</h3>
                                                </div>
                                                <div>
                                                    <label for="first_name"
                                                           class="block text-sm text-gray-900">
                                                        Title
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="first_name" v-model="form.title"
                                                               placeholder="Enter first name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.title}"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="first_name"
                                                           class="block text-sm text-gray-900">
                                                        First Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="first_name" v-model="form.first_name"
                                                               placeholder="Enter a first name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.first_name}"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="last_name"
                                                           class="block text-sm text-gray-900">
                                                        Last Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.last_name" id="last_name"
                                                               placeholder="Enter a last name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.last_name}"
                                                        />

                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="code"
                                                           class="block text-sm text-gray-900">
                                                        Code
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.code" id="code"
                                                               placeholder="Enter a short name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.code}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="job_title"
                                                           class="block text-sm text-gray-900">
                                                        Job Title
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.job_title"
                                                               id="job_title"
                                                               placeholder="Enter a job title"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.job_title}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="telephone"
                                                           class="block text-sm text-gray-900">
                                                        Telephone
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.telephone"
                                                               id="telephone"
                                                               placeholder="+44123456789"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.telephone}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="mobile"
                                                           class="block text-sm text-gray-900">
                                                        Mobile
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.mobile" id="mobile"
                                                               placeholder="+4412345678"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.mobile}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="commencement_of_contract"
                                                           class="block text-sm text-gray-900">
                                                        Commencement of Contract
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" v-model="form.commencement_of_contract"
                                                               id="commencement_of_contract"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.commencement_of_contract}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="end_of_employment"
                                                           class="block text-sm text-gray-900">
                                                        End of Employment
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" v-model="form.end_of_employment"
                                                               id="end_of_employment"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.end_of_employment}"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-6 pb-5 grid grid-cols-2 gap-4">
                                                <div class="col-span-2 mt-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">System
                                                        Information</h3>
                                                </div>
                                                <div class="col-span-1">
                                                    <label for="email"
                                                           class="block text-sm text-gray-900">
                                                        Email
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.email" id="email"
                                                               autocomplete="off"
                                                               placeholder="Enter an email address"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.email}"

                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-span-1">
                                                    <label for="role"
                                                           class="block text-sm text-gray-900">
                                                        Role
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="role" name="role" v-model="form.role"
                                                                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                                                            <option disabled value="">Select a role</option>
                                                            <option v-for="role in roles" :value="role.name"
                                                                    v-html="titleCase(role.name)"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="role"
                                                           class="block text-sm text-gray-900">
                                                        Main Office
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="role" name="role" v-model="form.office_id"
                                                                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                                                            <option disabled value="">Select an main office</option>
                                                            <option v-for="office in offices" :value="office.id"
                                                                    v-html="office.name"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-6 pb-5 grid grid-cols-2 gap-4">
                                                <div class="col-span-2 mt-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">Additional
                                                        Offices</h3>
                                                </div>
                                                <div class="relative flex items-start col-span-1" v-for="office in offices">
                                                    <div class="flex h-5 items-center">
                                                        <input
                                                            type="checkbox"
                                                            v-model="form.additional_offices" :value="office.id"  class="h-4 w-4 rounded border-gray-300 text-amaze-coral focus:ring-amaze-coral">
                                                    </div>
                                                    <div class="ml-3 text-sm">
                                                        <label for="comments" class="font-medium text-gray-700" v-html="office.name"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="updating === false" class="pt-4 pb-6">
                                                <div class="mt-4 flex text-sm">
                                                    <div
                                                        class="inline-flex items-center text-gray-500">
                                                        <ExclamationCircleIcon
                                                            class="h-16 w-16 block text-gray-400"
                                                            aria-hidden="true"/>
                                                        <span class="ml-2">
                                                          Once submitted, the user will receive an email inviting them to create a password and log onto the system.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {useForm} from '@inertiajs/vue3'
import Inertia from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors.vue";
import {mapState} from "vuex";


export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        ExclamationCircleIcon,
        XIcon,
    },
    setup(prop, context) {

        const show = ref(false)

        const showErrors = ref(false)

        const updating = false;

        const form = useForm({
            id: null,
            title: null,
            first_name: null,
            last_name: null,
            code: null,
            job_title: null,
            telephone: null,
            mobile: null,
            email: null,
            role: '',
            password: null,
            password_confirmation: null,
            office_id: '',
            additional_offices: []
        })

        function submit() {
            if (this.updating) {
                this.form.post(route('admin.users.user.update', this.form.id), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            } else {
                this.form.post(route('admin.users.create'), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            }
        }

        function close() {
            this.show = false;
            this.form.reset();
            this.form.clearErrors();
        }

        function open() {
            this.form.clearErrors();
            this.$store.dispatch('users/getData')
            this.show = true;
        }

        return {
            show,
            form,
            submit,
            updating,
            close,
            open,
            showErrors
        }
    },
    computed: {
        ...mapState({
            offices: state => state.users.offices ?? null,
            roles: state => state.users.roles ?? null
        }),
    }
}
</script>
